import React, { useEffect, useState } from "react";
import MainLayout from "Screens/components/MainLayout";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_blogs } from "http/components/Requests";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { set_BlogData } from "../../Redux/slices/dataSlice";
import Blogs from "./components/Blogs";

export default function BlogsIndex() {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      dispatch(HandleLoading(true));
      await blogs();
      dispatch(HandleLoading(false));
    })();
  }, []);

  const blogs = async () => {
    const response = await get_blogs();
    if (CheckApiStatus(response)) {
      dispatch(set_BlogData(response.data.infos));
    }
  };

  return <MainLayout flat pageContent={<Blogs />} />;
}
